import { graphql } from '../../gql';

/**
 * Lightweight composition query that fetches only headcount metrics.
 * Used on overview pages where only the headcount line chart is needed,
 * avoiding the full breakdown payload (gender, ethnicity, role, etc.).
 */
export const COMPOSITION_HEADCOUNT_ONLY = graphql(`
  query CompositionHeadcountOnly(
    $entities: [CompositionV2Entity!]!
    $filters: CompositionV2Filters!
  ) {
    composition_v2(req: { filters: $filters, entities: $entities }) {
      entities {
        metadata {
          id
          short_name
          long_name
          type
        }
        metrics {
          headcount {
            id
            value
          }
        }
      }
      refs {
        months
      }
    }
  }
`);

export const COMPOSITION_GET_DATA_V2 = graphql(`
  query CompositionV2Data(
    $entities: [CompositionV2Entity!]!
    $filters: CompositionV2Filters!
    $breakdownOptions: CompositionV2BreakdownOptions
  ) {
    composition_v2(
      req: {
        filters: $filters
        entities: $entities
        breakdown_options: $breakdownOptions
      }
    ) {
      entities {
        metadata {
          id
          short_name
          long_name
          type
        }
        metrics {
          headcount {
            id
            value
          }
          tenure {
            id
            value
          }
          salary {
            id
            value
          }
          growth_rate {
            id
            value
          }
          hiring_rate {
            id
            value
          }
          attrition_rate {
            id
            value
          }
          gender {
            metadata {
              id
              short_name
              long_name
            }
            timeseries {
              id
              count
              share
            }
          }
          ethnicity {
            metadata {
              id
              short_name
              long_name
            }
            timeseries {
              id
              count
              share
            }
          }
          role {
            metadata {
              id
              short_name
              long_name
            }
            timeseries {
              id
              count
              share
            }
          }
          geography {
            metadata {
              id
              short_name
              long_name
            }
            timeseries {
              id
              count
              share
            }
          }
          seniority {
            metadata {
              id
              short_name
              long_name
            }
            timeseries {
              id
              count
              share
            }
          }
          education {
            metadata {
              id
              short_name
              long_name
            }
            timeseries {
              id
              count
              share
            }
          }
          rics {
            metadata {
              id
              short_name
              long_name
            }
            timeseries {
              id
              count
              share
            }
          }
          skills {
            metadata {
              id
              short_name
              long_name
            }
            timeseries {
              id
              count
              share
            }
          }
        }
      }
      refs {
        months
      }
    }
  }
`);
